import type { MobileHomeAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AnnualTax } from "../AnnualTax.tsx";
import { Width } from "../boat/Width.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Condition } from "../Condition.tsx";
import { ConditionReport } from "../ConditionReport.tsx";
import { Engine } from "../Engine.tsx";
import { FirstRegistration } from "../FirstRegistration.tsx";
import { Fuel } from "../Fuel.tsx";
import { LengthCm } from "../LengthCm.tsx";
import { Make } from "../Make.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { NoOfSleepers } from "../NoOfSleepers.tsx";
import { Owners } from "../Owners.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { RegistrationTax } from "../RegistrationTax.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { TradeType } from "../TradeType.tsx";
import { Transmission } from "../Transmission.tsx";
import { RVWeight } from "../Weight.tsx";
import { WheelDrive } from "../WheelDrive.tsx";
import { BedType } from "./BedType.tsx";
import { ChassisType } from "./ChassisType.tsx";
import { MobileHomeLocation } from "./MobileHomeLocation.tsx";
import { NoOfSeats } from "./NoOfSeats.tsx";
import { Type } from "./Type.tsx";

export const MobileHomeSpecifications = ({ ad }: { ad: MobileHomeAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*Tax information*/}
        <RegistrationTax {...(ad.price ?? {})} />
        <AnnualTax annualTaxUrl={ad.annual_tax_url} />
        {/*General information*/}
        <Condition condition={ad.condition} />
        <Make make={ad.make} />
        <ModelYear year={ad.year} />
        <Type segment={ad.segment} />
        <ChassisType chassisType={ad.chassis_type} />

        {/*Product properties*/}
        <Fuel fuel={ad.engine?.fuel} />
        <Engine engine={ad.engine} />
        <Transmission transmission={ad.transmission} />
        <WheelDrive wheelDrive={ad.wheel_drive} />
        <LengthCm lengthCm={ad.length} />
        <Width width={ad.width} />
        <RVWeight weight={ad.weight} />
        <NoOfSeats noOfSeats={ad.no_of_seats} />
        <NoOfSleepers noOfSleepers={ad.no_of_sleepers} />
        <BedType bed={ad.bed} />

        {/*Appearance*/}

        {/*Registration, warranty, owners, etc*/}
        <MobileHomeLocation mobilehomeLocation={ad.mobilehome_location} />
        <RegistrationNumber registrationNumber={ad.registration_number} />
        <FirstRegistration firstRegistration={ad.first_registration} />
        <ChassisNumber chassisNumber={ad.chassis_number} />
        <Owners owners={ad.owners} />
        <ConditionReport conditionReport={ad.condition_report} />
        <TradeType tradeType={ad.trade_type} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
